<template>
  <Page>
    <template slot="header">
      <transition name="fade"><img v-if="isLoading" src="./assets/loader.svg" id="loader"></transition>
      <div class="small-12 medium-2 columns"><img src="./assets/logo.png"></div>
      <div class="small-12 medium-6 columns"><MainMenu :routes="mainMenuRoutes"></MainMenu></div>
      <div class="small-12 medium-2 columns"><div id="credit" class="secondary label">{{ 'Credit %d'|t(getUserCredit) }}</div></div>
      <div class="small-12 medium-2 columns"><LanguageSelector></LanguageSelector></div>
    </template>
    <template slot="main">
      <Messages :errors="errorMessages" :statuses="statusMessages" :warnings="warningMessages"></Messages>
      <div v-if="showSideMenu" class="small-2 columns">
        <SideMenu :routes="sideMenuRoutes"></SideMenu>
        <div v-if="isAuthed" id="userid" :title="'Logged in as user #' + userId"><i class="icon icon-user"></i> #{{ userId }}</div>
      </div>
      <div :class="showSideMenu ? 'small-10 columns' : 'small-12 columns'">
        <h1 id="page-title" v-if="pageTitle">{{ pageTitle|t }}</h1>
        <LocalTasks :routes="localTasks"></LocalTasks>
        <ActionsMenu :routes="localActions"></ActionsMenu>
        <router-view/>
      </div>
    </template>
  </Page>
</template>

<script>
  import Page from '@/components/Page'
  import Messages from '@/components/Messages'
  import LanguageSelector from '@/components/LanguageSelector'
  import MainMenu from '@/components/MainMenu'
  import SideMenu from '@/components/SideMenu'
  import LocalTasks from '@/components/LocalTasks'
  import ActionsMenu from '@/components/ActionsMenu'
  import '@/assets/foundation.css';
  import '@/assets/icomoon.css';
  import '@/assets/app.css';
  import router from '@/routes';

export default {
  name: 'App',
  components: {
    Page,
    Messages,
    LanguageSelector,
    MainMenu,
    SideMenu,
    LocalTasks,
    ActionsMenu,
  },
  computed: {
    getUserCredit() {
      return this.$store.getters['auth/getCredit']
    },
    errorMessages() {
      return this.$store.getters['messages/getErrorMessages']
    },
    warningMessages() {
      return this.$store.getters['messages/getWarningMessages']
    },
    statusMessages() {
      return this.$store.getters['messages/getStatusMessages']
    },
    isAdmin() {
      return this.$store.getters['auth/isAdmin']
    },
    isAuthed() {
      return this.$store.getters['auth/isAuthed']
    },
    isAnonym() {
      return !this.$store.getters['auth/isAuthed']
    },
    showSideMenu() {
      return this.sideMenuRoutes.length > 0
    },
    isLoading() {
      return this.$store.getters['isLoading']
    },
    pageTitle() {
      return this.$store.getters['pageTitle']
    },
    localTasks() {
      let user = {
        id: this.userId,
        roles: this.isAdmin ? ['admin'] : []
      };
      return this.$store.getters['localTasks'].filter(function(value) {
          for (let i in router.options.routes) {
            let route = router.options.routes[i];
            if (route.name === value.name) {
              let access = route.meta.access;
              if (typeof route.meta.access === "function") {
                access = route.meta.access(user);
              }
              if (access !== true) {
                return false;
              }
            }
          }
          return true;
      });
    },
    localActions() {
      let user = {
        id: this.userId,
        roles: this.isAdmin ? ['admin'] : []
      };
      return this.$store.getters['localActions'].filter(function(value) {
        for (let i in router.options.routes) {
          let route = router.options.routes[i];
          if (route.name === value.name) {
            let access = route.meta.access;
            if (typeof route.meta.access === "function") {
              access = route.meta.access(user);
            }
            if (access !== true) {
              return false;
            }
          }
        }
        return true;
      });
    },
    sideMenuRoutes() {
      let user = {
        id: this.userId,
        roles: this.isAdmin ? ['admin'] : []
      };
      let routes = [];
      router.options.routes.forEach(function(route) {
        if (route.meta && route.meta.side_menu) {
          let access = route.meta.access;
          if (typeof route.meta.access === "function") {
            access = route.meta.access(user);
          }
          if (access !== true) {
            return;
          }

          routes.push({
            name: route.name,
            icon: route.meta.side_menu.icon,
            label: route.meta.side_menu.label,
            weight: route.meta.side_menu.weight || 0
          });
        }
      });

      routes.sort(function(a, b) {
        if (a.weight === b.weight) {
          // this will not work properly for translations
          return a.label.localeCompare(b.label);
        }
        return a.weight > b.weight ? 1 : -1;
      });

      return routes;
    },
    mainMenuRoutes() {
      let user = {
        id: this.userId,
        roles: this.isAdmin ? ['admin'] : []
      };
      let routes = [];
      router.options.routes.forEach(function(route) {
        if (route.meta && route.meta.main_menu) {
          let access = route.meta.access;
          if (typeof route.meta.access === "function") {
            access = route.meta.access(user);
          }
          if (access !== true) {
            return;
          }

          routes.push({
            name: route.name,
            icon: route.meta.main_menu.icon,
            label: route.meta.main_menu.label,
            weight: route.meta.main_menu.weight || 0
          });
        }
      });

      routes.sort(function(a, b) {
        if (a.weight === b.weight) {
          // this will not work properly for translations
          return a.label.localeCompare(b.label);
        }
        return a.weight > b.weight ? 1 : -1;
      });

      return routes;
    },
    userId() {
      return this.$store.getters['auth/getUserId'];
    },
  },
  created() {
    this.$store.dispatch('auth/extendSession')
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue